export enum Gender {
  Female = 'Female',
  Male = 'Male',
  TransMan = 'TransMan',
  TransWoman = 'TransWoman',
}

export const genderOptions = [{
  value: Gender.Female,
  label: Gender.Female.toString(),
}, {
  value: Gender.Male,
  label: Gender.Male.toString(),
}, {
  value: Gender.TransMan,
  label: Gender.TransMan.toString(),
}, {
  value: Gender.TransWoman,
  label: Gender.TransWoman.toString(),
}]

